/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Filter criteria for searching tool calls
 */
export type SearchToolCallsFilter = {
  /**
   * Deployment ID filter
   */
  deploymentId?: string | undefined;
  /**
   * Event source filter (e.g., 'hook', 'tool_call', 'chat_completion')
   */
  eventSource?: string | undefined;
  /**
   * Start time in ISO 8601 format (e.g., '2025-12-19T10:00:00Z')
   */
  from?: Date | undefined;
  /**
   * Function ID filter
   */
  functionId?: string | undefined;
  /**
   * Speakeasy URN filter (single URN, use gram_urns for multiple)
   */
  gramUrn?: string | undefined;
  /**
   * End time in ISO 8601 format (e.g., '2025-12-19T11:00:00Z')
   */
  to?: Date | undefined;
};

/** @internal */
export type SearchToolCallsFilter$Outbound = {
  deployment_id?: string | undefined;
  event_source?: string | undefined;
  from?: string | undefined;
  function_id?: string | undefined;
  gram_urn?: string | undefined;
  to?: string | undefined;
};

/** @internal */
export const SearchToolCallsFilter$outboundSchema: z.ZodMiniType<
  SearchToolCallsFilter$Outbound,
  SearchToolCallsFilter
> = z.pipe(
  z.object({
    deploymentId: z.optional(z.string()),
    eventSource: z.optional(z.string()),
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    functionId: z.optional(z.string()),
    gramUrn: z.optional(z.string()),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      eventSource: "event_source",
      functionId: "function_id",
      gramUrn: "gram_urn",
    });
  }),
);

export function searchToolCallsFilterToJSON(
  searchToolCallsFilter: SearchToolCallsFilter,
): string {
  return JSON.stringify(
    SearchToolCallsFilter$outboundSchema.parse(searchToolCallsFilter),
  );
}
